export default __webpack_public_path__ + "static/media/google-g-2015.094423a8.svg";